import { render } from "./CreateProgram.vue?vue&type=template&id=0323e078"
import script from "./CreateProgram.vue?vue&type=script&lang=js"
export * from "./CreateProgram.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__